import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
    color: 'rgba(255, 255, 255, 0.5)',
  },
  logoContainer: {
    marginBottom: theme.spacing(3),
  },
  logoWrapper: {
    display: 'inline-block',
  },
  logo: {
    maxHeight: 96,
    maxWidth: 320,
  },
  subtitle: {
    margin: theme.spacing(4, 0),
  },
  subtitleNotAlternative: {
    '& .MuiTypography-root': {
      color: '#FFF',
    },
  },
  avatar: {
    backgroundColor: 'transparent !important',
    color: `${theme.palette.secondary.dark} !important`,
    borderRadius: '9999px !important',
    width: 'auto !important',
    minWidth: '48px !important',
    '& img': {
      minHeight: '48px !important',
      minWidth: '48px !important',
      width: 'auto !important',
      margin: `${theme.spacing(1)} !important`,
    },
  },
  link: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  item: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
}))
